import React, { FC } from 'react';
import { NoticeBoxStyled, Title, Content } from './NoticeBox.styles';

type NoticeBoxProps = {
  title: string | JSX.Element;
  content: string | JSX.Element;
};

export const NoticeBox: FC<NoticeBoxProps> = ({ title, content }) => (
  <NoticeBoxStyled>
    <Title>{title}</Title>
    <Content>{content}</Content>
  </NoticeBoxStyled>
);
